// Copyright (c) 2016 Deere & Company

import * as busyCounter from './busy-counter';
import actions from '../../actions-list';
import {getSearchResults} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';

export const updateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FILTER_BY
});

export const updateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_PART_REQUESTS_SEARCH_SORT_BY
});

export const updateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_PART_REQUESTS_SEARCH_SORT_DIRECTION
});

export const updateSearchBy = key => ({
    key,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_BY
});

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_QUERY_STRING
});

const getDateRange = searchResults => ({
    from: Math.min(...searchResults.map(searchResult => searchResult.requestDate)),
    to: Math.max(...searchResults.map(searchResult => searchResult.requestDate))
});

export const updateSearchResults = query =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const state = getState();

        const searchBy = state.partReturns.search.searchByDropdown.selectedOption.key;

        try {

            const searchResults = await getSearchResults(query, searchBy);

            dispatch({
                searchResults,
                type: actions.UPDATE_PART_REQUESTS_SEARCH_RESULTS
            });

            dispatch({
                filteredSearchResults: searchResults,
                type: actions.FILTER_PART_REQUESTS_SEARCH_RESULTS
            });

            dispatch(routerActions.push(`/part-requests/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

            if (searchResults.length) {

                dispatch({
                    dateRange: getDateRange(searchResults),
                    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DATE_RANGE
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/search/action-creators/search.js